import React from 'react';
import {  FiEdit2  } from "react-icons/fi";
import { Skills } from './skills';

export const Skillset = ({type}) => {
    const [tabIndex, setTabIndex] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const toggle = () => setOpen(!open);
    return (
        <ul>
            <li>
                <div className="profile_component">
                    <div className="tabs">
                        <div className="flex">
                            <ul className="flex-start">
                                <li className={`tab ${tabIndex===0 ? 'active':''} `} onClick={()=>setTabIndex(0)} > Job </li>
                                <li className={`tab ${tabIndex===1 ? 'active':''} `} onClick={()=>setTabIndex(1)} > Personal </li>
                                <li className="tab" onClick={toggle}><FiEdit2 /> {open ? 'Private' : 'Public'} </li>
                            </ul>
                            <ul>
                            </ul>
                        </div>

                        <div className={`panel ${tabIndex!==0?'hide':''}`}>
                            <Skills open={open} data={[]} title="Skills" type={`${type||'user-edit'}-job`} mode={'job'} />
                        </div>
                        <div className={`panel ${tabIndex!==1?'hide':''}`}>
                            <Skills open={open} data={[]} title="Personal skills"  type={`${type||'user-edit'}-personal`} mode={'personal'} />
                        </div>

                    </div>
                </div>
            </li>
        </ul>
    )
}